document.addEventListener('DOMContentLoaded', () => {
  const qtyBar = document.querySelector('.qty-bar');
  if (!qtyBar) return;

  const minusBtn = qtyBar.querySelector('.minus');
  const plusBtn  = qtyBar.querySelector('.plus');
  if (!minusBtn || !plusBtn) return;

  // cached nodes used multiple times
  const drawer            = document.getElementById('cart-drawer-unique');
  const cartCountElement  = document.querySelector('#count-mobile-cart .dev_cart_count');
  const cartUrlBase       = (window.routes && window.routes.cart_url) || '/cart';

  // --- helpers ---

  async function getCartCount() {
    const cart = await fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    }).then((r) => r.json());
    return { cart_count: Number(cart?.item_count || 0), cart_item: cart.items };
  }

  function setEmptyClassByCount(count) {
    if (!drawer) return;
    drawer.classList.toggle('is-empty', count === 0);
  }

  async function cartLoaderShowHide(show_hide) {
    const cartloader = document.querySelector('.uc-c-cart-loader');
    if (!drawer || !cartloader) return;
    drawer.classList.toggle('newcartdrawerV', !!show_hide);
  }

  async function updateCartUI(openDrawer = false) {
    const res = await fetch(
      `${cartUrlBase}?sections=cart-drawer,cart-icon-bubble`,
      { credentials: 'same-origin' }
    );
    const sections = await res.json();

    const cartEl =
      document.querySelector('cart-notification') ||
      document.querySelector('cart-drawer');

    if (cartEl?.renderContentsCustom) {
      cartEl.renderContentsCustom(sections, openDrawer);
    }

    const bubbleHtml  = sections['cart-icon-bubble'];
    const bubbleMount = document.querySelector('[data-cart-icon-bubble], #cart-icon-bubble');
    if (bubbleHtml && bubbleMount) {
      const tmp = document.createElement('div');
      tmp.innerHTML = bubbleHtml.trim();
      const fresh = tmp.querySelector('[data-cart-icon-bubble], #cart-icon-bubble');
      if (fresh) bubbleMount.replaceWith(fresh);
    }
  }

  // single-call add/set (no pre-GET)
  async function addOrSetCartQty(variantId, qty) {
    const vid = Number(variantId);
    const q   = Number(qty);
    if (!Number.isFinite(vid)) throw new Error('Invalid variantId');
    if (!Number.isInteger(q) || q < 0) throw new Error('Invalid quantity');

    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: { [vid]: q } }),
    });
    if (!res.ok) throw new Error('cart update failed');
    return res.json(); // updated cart JSON
  }

  function toggleAtc(showQtyBar, qty = 0) {
    const bar = document.querySelector('#pdp-add-to-cart-fn');
    const cta = document.querySelector('#pdp-add-to-cart-fnp');

    const q = showQtyBar ? Math.max(1, parseInt(qty, 10) || 1) : 1;

    if (bar) {
      const v = bar.querySelector('.qty-value');
      if (v) v.textContent = String(q);

      const hid = bar.querySelector('input[name="quantity"]');
      if (hid) hid.value = String(q);

      bar.style.display = showQtyBar ? 'flex' : 'none';
    }

    if (cta) {
      cta.style.display = showQtyBar ? 'none' : 'block';
    }
  }

  async function fetchCartItems() {
    const r = await fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });
    const cart = await r.json();
    return Array.isArray(cart?.items) ? cart.items : [];
  }

  // shared helper reused in submit
  function totalQtyForVariant(items, variantId) {
    const idStr = String(variantId);
    return items.reduce(
      (sum, item) =>
        String(item.variant_id) === idStr
          ? sum + (Number(item.quantity) || 0)
          : sum,
      0
    );
  }

  // ---------- variant selection / state ----------

  let busy                = false;
  let lastId              = null;
  let refreshForVariantId = null;
  let running             = Promise.resolve();

  async function refreshForVariant(variantId) {
    const id = variantId != null ? String(variantId) : null;
    if (!id || id === lastId) return;

    running = running
      .then(async () => {
        const items = await fetchCartItems();
        const totalQty = items.reduce(
          (sum, it) =>
            sum + (String(it?.id) === id ? Number(it?.quantity || 0) : 0),
          0
        );
        toggleAtc(totalQty > 0, totalQty);
        lastId = id;
      })
      .catch((e) => {
        if (e?.name !== 'AbortError') console.warn(e);
      });

    await running;
    refreshForVariantId = id;
  }

  function setActiveSwatch(btn) {
    const group = btn.closest('.option-buttons') || btn.parentElement;
    group
      ?.querySelectorAll('.rectanglular-color-buttons.v_active, .variant-btn.v_active')
      .forEach((b) => b.classList.remove('v_active'));
    btn.classList.add('v_active');
  }

  function setHiddenVariantInput(id) {
    const input = document.querySelector(
      'form[action^="/cart/add"] input[name="id"]'
    );
    if (input) input.value = String(id);
  }

  (function initColorSwatches() {
    const root = document.querySelector('.option-buttons') || document;

    root.addEventListener('click', (e) => {
      const btn = e.target.closest('.rectanglular-color-buttons, .variant-btn');
      if (!btn) return;

      if (btn.tagName === 'BUTTON' && !btn.hasAttribute('type')) {
        btn.setAttribute('type', 'button');
      }
      e.preventDefault();

      const vid = btn.getAttribute('data-variant-id');
      refreshForVariantId = vid;
      if (!vid) return;

      setActiveSwatch(btn);
      setHiddenVariantInput(vid);
      refreshForVariant(vid);

      const box = document.querySelector('.devx_pdp_add_to_cart');
      if (box) {
        const input = box.querySelector('input[name="product-id"]');
        if (input) input.value = vid;
      }
    });

    document.addEventListener('variant:change', (ev) => {
      const vid = ev?.detail?.variant?.id;
      if (vid) refreshForVariant(String(vid));
    });

    const initialActive = document.querySelector(
      '.rectanglular-color-buttons.v_active, .variant-btn.v_active'
    );
    const initialId =
      initialActive?.getAttribute('data-variant-id') ||
      document.querySelector('#pdp-add-to-cart-fn')?.dataset
        ?.defaultVarientIdCs ||
      null;
    if (initialId) refreshForVariant(initialId);
  })();

  // ---------- quantity event handler functions plus/minus ----------

  plusBtn.addEventListener('click', async (e) => {
    if (busy) return;
    const variantId = refreshForVariantId;
    if (!variantId) {
      console.warn('No active variant selected');
      return;
    }

    const bar = e.currentTarget.closest('.qty-bar') || qtyBar;
    const valueEl = bar?.querySelector('.qty-value');
    if (!valueEl) return;

    let value = parseInt(valueEl.textContent, 10) || 0;
    value = value + 1;
    valueEl.textContent = String(value);

    try {
      busy = true;
      await cartLoaderShowHide(true);

      // 1️⃣ update cart, 2️⃣ then refresh UI (avoids race condition)
      const updated = await addOrSetCartQty(variantId, value);
      await updateCartUI(false);

      const count = Number(updated?.item_count || 0);
      if (cartCountElement) cartCountElement.textContent = String(count);
      setEmptyClassByCount(count);
    } catch (err) {
      console.error('cart update failed:', err);
    } finally {
      busy = false;
      await cartLoaderShowHide(false);
    }
  });

  minusBtn.addEventListener('click', async (e) => {
    if (busy) return;
    const variantId = refreshForVariantId;
    if (!variantId) {
      console.warn('No active variant selected');
      return;
    }

    const bar = e.currentTarget.closest('.qty-bar') || qtyBar;
    const valueEl = bar?.querySelector('.qty-value');
    if (!valueEl) return;

    let value = parseInt(valueEl.textContent, 10) || 0;
    if (value <= 0) return;
    value = value - 1;
    valueEl.textContent = String(value);

    try {
      busy = true;
      await cartLoaderShowHide(true);

      const updated = await addOrSetCartQty(variantId, value);
      await updateCartUI(false);

      const count = Number(updated?.item_count || 0);
      if (cartCountElement) cartCountElement.textContent = String(count);

      const matchCount = (updated?.items || []).reduce((n, it) => {
        return n + (Number(it.id) === Number(variantId) ? 1 : 0);
      }, 0);

      setEmptyClassByCount(count);
      if (matchCount === 0) toggleAtc(false);
    } catch (err) {
      console.error('cart update failed:', err);
    } finally {
      busy = false;
      await cartLoaderShowHide(false);
    }
  });

  // ---------- ATC submit interception ----------

  async function handleAtcSubmit(productId) {
    if (busy) return;
    if (!productId) {
      console.warn('No active variant selected');
      return;
    }

    const variantId = productId;

    try {
      busy = true;
      await cartLoaderShowHide(true);

      // keep existing logic: use /cart.js to compute matchedCount
      const count_objects = await getCartCount();
      const count_itemss  = count_objects.cart_item;

      const matchedCount = totalQtyForVariant(count_itemss, variantId);
      const value        = matchedCount + 1;

      const res_add = await addOrSetCartQty(variantId, value);
      await updateCartUI(false);

      const count = Number(res_add?.item_count || 0);
      if (cartCountElement) cartCountElement.textContent = String(count);
      setEmptyClassByCount(count);

      if (res_add.items?.length > 0) {
        if (drawer) drawer.classList.remove('active');
        setTimeout(() => {
          if (drawer) drawer.classList.remove('active_c');
        }, 200);

        toggleAtc(true);

        const bar = document.querySelector('.qty-bar');
        const el  = bar?.querySelector('.qty-value');
        if (el) el.textContent = String(value);
      }
    } catch (err) {
      console.error('cart update failed:', err);
    } finally {
      busy = false;
      await cartLoaderShowHide(false);
    }
  }

  // intercept submits from ATC buttons
  document.addEventListener(
    'submit',
    async function (e) {
      const form = e.target;
      if (drawer) drawer.classList.add('active_c');

      const isTargetForm =
        form.matches('.add-to-cart-form') ||
        (form.action && /\/cart\/add(\b|\/|\?)/i.test(form.action));

      const submitter = e.submitter || document.activeElement;
      const isTargetButton =
        !!submitter &&
        submitter.matches('.devx_add_to_cart_button, .dev_add_btn');

      if (!isTargetForm || !isTargetButton) return;

      e.preventDefault();
      e.stopPropagation();

      if (submitter.classList.contains('devx_add_to_cart_button')) {
        const productId =
          document.getElementById('product-varient-id')?.value?.trim() ||
          null;
        await handleAtcSubmit(productId);
      } else {
        const productId =
          document
            .querySelector('.product-variant-id-bottom')
            ?.value?.trim() || null;
        await handleAtcSubmit(productId);
      }
    },
    true
  );
});